import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { ViewCell } from "ng2-smart-table";

@Component({
    selector: 'checkbox-view',
    template: `
       <label class="checkbox-inline custom-checkbox nowrap">
       <nb-checkbox #chk  [checked]="value.row.checked" (checkedChange)="onChange(chk.checked)"></nb-checkbox>
        <span></span>
      </label>
    `,
    styles: [
      ':host { margin-top: -9px; left: -8px; }'
    ]
  })
  export class CheckboxButtonViewComponent implements ViewCell, OnInit {
  
    @Input() value: any;
    @Input() rowData: any;
  
    @Output() save: EventEmitter<any> = new EventEmitter<any>();
  
    ngOnInit() {
  
    }
  
    onChange(value) {
      this.value.row.checked = value;
    }
  }
  